import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"package-in,delivery"} maskId="square-filled-radius-0-stroke-1-IconPackageIn"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V12H20V4H16V10H8V4H4V20H13V21H3V3ZM17.2071 14.5L15.7071 16H19.5C20.8807 16 22 17.1193 22 18.5V21H21V18.5C21 17.6716 20.3284 17 19.5 17H15.7071L17.2071 18.5L16.5 19.2071L13.7929 16.5L16.5 13.7929L17.2071 14.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPackageIn;
